import { useMemo } from 'react';
import { collectorsPageRoute } from 'modules/Collectors/collectorsRoute';
import { TIRouteProps } from 'modules/common';
import { notesPageRoute } from 'modules/notes';
import { smartDiaryPageRoute } from 'modules/smartDiary';
import { SettingPageRoute } from 'modules/Settings/SettingsPageRoute';
import { useMeContext } from 'modules/me';
import { InsightsPageRoute } from 'modules/Insights/InsightsPageRoute';
import { useFeatureFlag } from 'modules/common/hooks';

export const useDefaultRoutes = (): TIRouteProps[] => {
  const me = useMeContext();
  const isTiWebNotesInsightsPageEnabled = useFeatureFlag(
    'isTiWebNotesInsightsPageEnabled'
  );
  return useMemo(() => {
    const defaultRoutes = [notesPageRoute, smartDiaryPageRoute];
    if (me?.permissions?.hasViewCollectorsAccess) {
      defaultRoutes.push(collectorsPageRoute);
    }
    if (
      me?.permissions?.hasStartEndEditAccess ||
      me?.permissions?.hasSmartSuggestionEditAccess
    ) {
      defaultRoutes.push(SettingPageRoute);
    }
    if (isTiWebNotesInsightsPageEnabled) {
      defaultRoutes.push(InsightsPageRoute);
    }
    return defaultRoutes;
  }, [
    isTiWebNotesInsightsPageEnabled,
    me?.permissions?.hasSmartSuggestionEditAccess,
    me?.permissions?.hasStartEndEditAccess,
    me?.permissions?.hasViewCollectorsAccess
  ]);
};
